import SingleTag from "@/components/Tags/tag.component";
import { ROUTE_TAGS } from "@/constants/routes.constants";
import {
  ContextMenu,
  ContextMenuContent,
  ContextMenuItem,
  ContextMenuTrigger,
} from "@/shadcn/components/ui/context-menu";
import { TagCategory } from "@/types";
import { ChevronDown, ChevronRight, ChevronsRight } from "lucide-react";
import React, { useState } from "react";
import { useNavigate } from "react-router";

type TagsViewSectionSelectCategoryProps = {
  viewingTagID: number | null;
  tagCat: TagCategory;
  additionalTagIDs: number[];
};

const TagsViewSectionSelectCategory: React.FC<
  TagsViewSectionSelectCategoryProps
> = ({ tagCat, viewingTagID, additionalTagIDs }) => {
  const [show, setShow] = useState(false);
  const nav = useNavigate();

  // useEffect(() => {
  //   // Parse the 'additionalTags' parameter from the URL
  //   const additionalTagsParam = searchParams.get("additionalTags");
  //   // console.log(additionalTagsParam);
  //   if (additionalTagsParam) {
  //     const parsedIDs = additionalTagsParam
  //       .split(",")
  //       .map((id) => Number(id))
  //       .filter((id) => !isNaN(id)); // Ensure all parsed IDs are valid numbers
  //     setAdditionalTagIDs(parsedIDs);
  //   } else {
  //     setAdditionalTagIDs([]); // Reset if the parameter is not present
  //   }
  // }, [searchParams]);

  function addTagToAdditional(tagID: number) {
    // update the additionalTags parameter in the URL with the new tagID
    const currentTags = new Set(additionalTagIDs);
    currentTags.add(tagID);
    const newTags = Array.from(currentTags).join(",");
    nav(`${ROUTE_TAGS}/${viewingTagID}?additionalTags=${newTags}`);
  }

  function removeTagFromAdditional(tagID: number) {
    // update the additionalTags parameter in the URL by removing the tagID
    const currentTags = new Set(additionalTagIDs);
    currentTags.delete(tagID);
    const newTags = Array.from(currentTags).join(",");
    nav(`${ROUTE_TAGS}/${viewingTagID}?additionalTags=${newTags}`);
  }

  return (
    <div className="flex flex-col gap-1 w-full">
      <div
        className="flex flex-row gap-2 items-center cursor-pointer"
        onClick={() => setShow(!show)}
      >
        {show ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
        <div className="font-bold">{tagCat.category}</div>
      </div>
      {show && (
        <div className="flex flex-col gap-0 w-full">
          {tagCat.tags
            // order by name alphabetically
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((tag) => (
              <ContextMenu key={tag.id + "_" + tagCat.id}>
                <ContextMenuTrigger>
                  <div
                    onClick={() =>
                      viewingTagID !== tag.id && nav(`${ROUTE_TAGS}/${tag.id}`)
                    }
                    className={`flex max-w-full w-fit p-1 rounded items-center gap-1 ${
                      viewingTagID === tag.id
                        ? ""
                        : additionalTagIDs.includes(tag.id)
                          ? " cursor-pointer"
                          : "cursor-pointer"
                    } `}
                  >
                    {viewingTagID === tag.id && (
                      <ChevronRight className="h-4" />
                    )}
                    {additionalTagIDs.includes(tag.id) && (
                      <ChevronsRight
                        className="h-4"
                        onClick={() => removeTagFromAdditional(tag.id)}
                      />
                    )}
                    <SingleTag
                      key={tag.id + "_" + tagCat.id}
                      id={tag.id + "_" + tagCat.id}
                      name={tag.name}
                      color={tag.color}
                      full={false}
                      className={`max-w-full`}
                    />
                  </div>
                </ContextMenuTrigger>
                {viewingTagID !== tag.id && (
                  <ContextMenuContent className="w-56">
                    {additionalTagIDs.includes(tag.id) ? (
                      <ContextMenuItem
                        onClick={() => {
                          removeTagFromAdditional(tag.id);
                        }}
                      >
                        Remove from additional tags
                      </ContextMenuItem>
                    ) : (
                      <ContextMenuItem
                        onClick={() => {
                          addTagToAdditional(tag.id);
                        }}
                      >
                        Add to additional tags
                      </ContextMenuItem>
                    )}
                  </ContextMenuContent>
                )}
              </ContextMenu>
            ))}
        </div>
      )}
    </div>
  );
};

export default TagsViewSectionSelectCategory;
